import classNames from 'classnames';
import type { FC, HTMLAttributes } from 'react';

import styles from './thead.module.scss';

export interface THeadProps extends HTMLAttributes<HTMLTableSectionElement> {
  isSticky?: boolean;
}

export const THead: FC<THeadProps> = ({ children, isSticky, ...props }) => (
  <thead className={classNames(styles.root, { [styles.sticky]: isSticky })} {...props}>
    <tr className={styles.thead_tr}>{children}</tr>
  </thead>
);
